import MenuIcon from './MenuIcon'

export default MenuIcon
